var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('template',{slot:"left"},[_c('publicMenu',{attrs:{"list":_vm.list,"iconUrl":"list"}})],1),_c('template',{slot:"right"},[_c('router-view')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }